<template>
    <div class="row">
        <div class="col-lg-12 col-md-12 col-12">
            <div class="customer-label-group mb-3">
                <div class="historyheader text-center">
                    PAN Details
                </div>
            </div>
        </div>
    </div>
    <div class="row">
        <div class="col-lg-8 col-md-8 col-12 mx-auto">
            <div class="pan-card-front-outer">
                <div class="pan-card-header-padding">
                    <div class="d-flex justify-content-between">
                        <div>
                            <img @dragstart.prevent @contextmenu.prevent
                                src="/assets/images/pan-card-images/incometax.png"
                                class="" alt style="height: 45px;" />
                        </div>
                        <div>
                            <img @dragstart.prevent @contextmenu.prevent
                                src="/assets/images/pan-card-images/emblem_black.png"
                                class="" alt style="height: 45px;" />
                        </div>
                        <div>
                            <img @dragstart.prevent @contextmenu.prevent
                                src="/assets/images/pan-card-images/indiagovpan.png"
                                class="" alt style="height: 45px;" />
                        </div>
                    </div>
                    <div class="d-flex align-items-top">
                        <div class="pan-card-detail-inner">
                            <div class="pan-name text-uppercase">{{
                                props.tenantowner.ai7
                                    ?
                                    props.tenantowner.ai7
                                    : "N/A"
                            }}</div>
                            <div class="pan-name text-uppercase"
                                v-if="props.tenantowner.ai7">
                                {{
                                    props.tenantowner.ai7.split(' ').slice(1, -1).join(' ')}}
                                {{
                                    props.tenantowner.ai7.split(' ').slice(-1).join(' ')}}
                            </div>
                            <div
                                class="pan-card-number-header text-capitalize">
                                Permanent Account Number</div>
                            <div class="pan-name text-uppercase">{{
                                props.tenantowner.ai6
                                    ?
                                    props.tenantowner.ai6
                                    : "N/A"
                            }}</div>
                        </div>
                        <div class="flex-shrink-0">
                            <img @dragstart.prevent @contextmenu.prevent
                                src="/assets/images/pan-card-images/hologrampan.png"
                                class="pan-code-image" alt="photo" />
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>
<script setup>
import { defineProps } from 'vue';

const props = defineProps({
  id: {
    type: [String, Number],
    required: true,
  },
  tenantowner: Object,
});
</script>
<style scoped>
.agreement-sub-tab-outer .historyheader {
    color: #0f0f0f;
    font-size: 18px;
    font-family: "OpenSans-Regular";
    line-height: 30px;
    text-align: center;
    margin-bottom: 15px;
}
</style>